// extracted by mini-css-extract-plugin
export default {"Mention":"Mention_Mention__EnbTn"};